import { useState, useEffect } from "react"
import List from "@mui/material/List"
import ListItemButton from "@mui/material/ListItemButton"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import Collapse from "@mui/material/Collapse"
import ExpandLess from "@mui/icons-material/ExpandLess"
import ExpandMore from "@mui/icons-material/ExpandMore"
import ArchivoItem from "./ArchivoItem"
import FolderIcon from '@mui/icons-material/Folder';

import { archivosIconos } from "./archivosIconos"

export default function ArchivoArea({ areaIndex, area }) {
  const [openItems, setOpenItems] = useState([])
  const [openSubAreas, setOpenSubAreas] = useState([])
  const toggleArea = (index) => {
    setOpenItems((prevOpenItems) => {
      const newOpenItems = [...prevOpenItems]
      newOpenItems[index] = !newOpenItems[index]
      return newOpenItems
    })
  }

  const toggleSubArea = (areaIndex, subAreaIndex) => {
    setOpenSubAreas((prevOpenSubAreas) => {
      const key = `${areaIndex}-${subAreaIndex}`
      const newOpenSubAreas = { ...prevOpenSubAreas }
      newOpenSubAreas[key] = !newOpenSubAreas[key]
      return newOpenSubAreas
    })
  }

  const obtenerIconoPorArea = (areaNombre) => {
    const area = archivosIconos.find((item) => item.area === areaNombre)
    return area ? area.icon : <FolderIcon/>
  }

  return (
    <div key={areaIndex}>
      {/* Área principal */}
      <ListItemButton onClick={() => toggleArea(areaIndex)}>
        <ListItemIcon>{obtenerIconoPorArea(area.area)}</ListItemIcon>
        <ListItemText
          primary={area.area}
          primaryTypographyProps={{ fontSize: "larger" }}
        />
        {openItems[areaIndex] ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      <Collapse in={openItems[areaIndex]} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {/* Si la área tiene subáreas, las renderizamos */}
          {area.subAreas.length > 0
            ? area.subAreas.map((subArea, subAreaIndex) => (
                <div key={`${areaIndex}-${subAreaIndex}`}>
                  {/* Subárea */}
                  <ListItemButton
                    onClick={() => toggleSubArea(areaIndex, subAreaIndex)}
                  >
                    <ListItemText primary={subArea.subArea} />
                    {openSubAreas[`${areaIndex}-${subAreaIndex}`] ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </ListItemButton>

                  <Collapse
                    in={openSubAreas[`${areaIndex}-${subAreaIndex}`]}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      {/* Archivos de la subárea */}
                      {subArea.archivos.map((archivo, archivoIndex) => (
                        <ArchivoItem
                          key={archivoIndex}
                          titulo={archivo.nombre}
                          descripcion={archivo.descripcion}
                          area={archivo.area}
                          filename={archivo.ruta}
                          indexItem={archivoIndex}
                        />
                      ))}
                    </List>
                  </Collapse>
                </div>
              ))
            : // Si no hay subáreas, mostrar los archivos directamente bajo la área
              area.archivos.length > 0 &&
              area.archivos.map((archivo, archivoIndex) => (
                <ArchivoItem
                  key={archivoIndex}
                  titulo={archivo.nombre}
                  descripcion={archivo.descripcion}
                  area={archivo.area}
                  filename={archivo.ruta}
                  indexItem={archivoIndex}
                />
              ))}
        </List>
      </Collapse>
    </div>
  )
}
